export function canAccessReservationsWaitlist({
  canViewReservations,
  demoModeActive,
} = {}) {
  return Boolean(canViewReservations) && !Boolean(demoModeActive);
}

const DEMO_READ_ONLY_ROUTE_PATTERNS = [
  /^\/$/,
  /^\/demo$/,
  /^\/reservations$/,
  /^\/reservations\/dashboard$/,
  /^\/reservations\/list$/,
  /^\/reservations\/availability$/,
  /^\/reservation-group\/[1-9]\d*$/,
  /^\/front-desk$/,
  /^\/front-desk\/check-ins$/,
  /^\/front-desk\/in-house$/,
  /^\/front-desk\/check-outs$/,
  /^\/rooms-management$/,
  /^\/rooms-management\/matrix$/,
  /^\/rooms-management\/assignment$/,
  /^\/rooms-management\/blocks$/,
  /^\/revenue-management-container$/,
  /^\/revenue-management-container\/management$/,
  /^\/revenue-management-container\/matrix$/,
  /^\/edit-room-rate\/[1-9]\d*$/,
  /^\/settings$/,
  /^\/settings\/reservation$/,
  /^\/settings\/front-desk$/,
  /^\/settings\/extras$/,
  /^\/settings\/charges$/,
  /^\/settings\/appearance$/,
  /^\/settings\/booking-engine$/,
];

export function isMutatingHttpMethod(method) {
  const normalizedMethod = String(method || "get").trim().toLowerCase();
  return !["get", "head", "options"].includes(normalizedMethod);
}

export function getDemoReadOnlyRedirectPath({
  pathname,
  search,
  demoModeActive,
  demoBusinessUnitId,
} = {}) {
  if (!demoModeActive) return "";

  const normalizedPath = `/${String(pathname || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")}`;
  const isReadOnlyRoute = DEMO_READ_ONLY_ROUTE_PATTERNS.some((pattern) =>
    pattern.test(normalizedPath)
  );

  if (normalizedPath === "/reservations/waitlist") {
    return "/reservations/list";
  }

  const isDemoEntryRoute = normalizedPath === "/" || normalizedPath === "/demo";
  if (isReadOnlyRoute && !isDemoEntryRoute && demoBusinessUnitId != null) {
    const requestedBusinessUnitId = new URLSearchParams(String(search || ""))
      .get("business_unit_id");
    if (String(requestedBusinessUnitId || "") !== String(demoBusinessUnitId)) {
      return normalizedPath;
    }
  }

  return isReadOnlyRoute ? "" : "/reservations/dashboard";
}
